import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/views/layout/Layout'

Vue.use(Router)
export const constantRouterMap = [
  {
    path: '/',
    component: layout,
    redirect:'/index',
    children: [{
        path: '/index',
        name: 'index',
        meta: { title: '首页' },
        component: () =>import ('@/views/index/index')
    },{
      path: '/detail/index',
      name: 'detail',
      meta: { title: '电子杂志' },
      component: () =>import ('@/views/detail/index')
  },{
    path: '/detail/index',
    name: 'details',
    meta: { title: '电子杂志' ,fatherName:'magazine'},
    component: () =>import ('@/views/detail/index')
},{
      path: '/detail/article',
      name: 'articleDetail',
      meta: { title: '文章详情',fatherName:'detail'},
      component: () =>import ('@/views/detail/article')
  },{
    path: '/detail/article',
    name: 'articleDetails',
    meta: { title: '文章详情',fatherName:'magazine'},
    component: () =>import ('@/views/detail/article')
},{
      path: '/magazine/index',
      name: 'magazine',
      meta: { title: '搜索详情' ,keepAlive:true},
      component: () =>import ('@/views/magazine/index')
  },{
    path: '/detail/read',
    name: 'details',
    meta: { title: '电子杂志' ,fatherName:'magazine'},
    component: () =>import ('@/views/detail/read')
},{
  path: '/ebook',
  name: 'ebook',
  meta: { title: '阅读器' },
  component: () =>
      import ('@/components/Ebook/ebook')
},]
  }
]
export default new Router({
  routes:constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js